import { Injectable } from '@angular/core';
import { ApiService } from '../..';
import { DatetimeService } from '../../index'
import { UserService } from 'app/services/common/user.service';

@Injectable()
export class ChatLuongRoutingService {

  APIURL = "api/SendByteTCP/DTT";
  constructor(public api: ApiService, public dateService: DatetimeService, private userService: UserService) {
  }
  //Lấy tất cả imei của điện lực/ trạm được chọn
  getImei(danhmucid) {
    var param = {
      "config": '{"namesql":"PKG_THONGKE_CHATLUONG_HT.P_LAYDS_IMEI"}',
      "para": '{"v_danhmucid":"' + danhmucid + '"}'
    };
    return this.api.Excute("api/ExcuteOracle", param);
  }
  //Lấy dữ liệu
  getData(danhmucid, imei, tungay, denngay, sotrang, sodong) {
    var param = {
      config: JSON.stringify({ namesql: "PKG_TRANGTHAIKETNOIRFMESH.P_LAYDS_GIAMSAT_ROUTING" }),
      para: JSON.stringify({
        v_danhmucid: danhmucid,
        v_imei: imei,
        v_tungay: tungay,
        v_denngay: denngay,
        v_sotrang: sotrang,
        v_sodong: sodong,
      })
    };
    return this.api.Excute("api/ExcuteOracle", param);
  }
  //Xuất excel
  exportExcel(tenDanhmuc, danhmucid, imei, tungay, denngay, songay) {
    songay = parseInt(songay);
    let fromDate = this.dateService.strToDatetime(tungay, 'DD/MM/YYYY');
    let ngay1 = this.dateService.convertDatetoDateOnlyString(this.dateService.addDateTime(fromDate, 1));
    let ngay2 = this.dateService.convertDatetoDateOnlyString(this.dateService.addDateTime(fromDate, 2));
    let ngay3 = this.dateService.convertDatetoDateOnlyString(this.dateService.addDateTime(fromDate, 3));
    let ngay4 = this.dateService.convertDatetoDateOnlyString(this.dateService.addDateTime(fromDate, 4));
    let ngay5 = this.dateService.convertDatetoDateOnlyString(this.dateService.addDateTime(fromDate, 5));
    let ngay6 = this.dateService.convertDatetoDateOnlyString(this.dateService.addDateTime(fromDate, 6));
    let cols = [];
    let filename = "Chatluongrouting_" + tenDanhmuc + "_" + tungay + "_" + denngay + '.xlsx';
    if (songay == 1) {
      cols = [
        { "name": "stt", "label": "STT", "horizontalalignment": "center" },
        { "name": "serial", "label": "Serial", "horizontalalignment": "right" },
        { "name": "type", "label": "Chủng loại", "horizontalalignment": "left" },
        { "name": "version", "label": "Version", "horizontalalignment": "center" },
        { "name": "rfid", "label": "RFID", "horizontalalignment": "right" },
        { "name": "direction", "label": "Định tuyến", "horizontalalignment": "left" },
        { "name": "thoidiemgannhat", "label": "Thời gian gần nhất", "horizontalalignment": "center" },
        { "name": "status_now", "label": "Kết quả routing hiện tại", "horizontalalignment": "left" },
        { "name": "ngay1_tt", "label": tungay, "horizontalalignment": "left" },
        { "name": "tyle", "label": "Tỷ lệ (%)", "horizontalalignment": "right" },
      ]
    }
    if (songay == 2) {
      cols = [
        { "name": "stt", "label": "STT", "horizontalalignment": "center" },
        { "name": "serial", "label": "Serial", "horizontalalignment": "right" },
        { "name": "type", "label": "Chủng loại", "horizontalalignment": "left" },
        { "name": "version", "label": "Version", "horizontalalignment": "center" },
        { "name": "rfid", "label": "RFID", "horizontalalignment": "right" },
        { "name": "direction", "label": "Định tuyến", "horizontalalignment": "left" },
        { "name": "thoidiemgannhat", "label": "Thời gian gần nhất", "horizontalalignment": "center" },
        { "name": "status_now", "label": "Kết quả routing hiện tại", "horizontalalignment": "left" },
        { "name": "ngay1_tt", "label": tungay, "horizontalalignment": "left" },
        { "name": "ngay2_tt", "label": ngay1, "horizontalalignment": "left" },
        { "name": "tyle", "label": "Tỷ lệ (%)", "horizontalalignment": "right" },
      ]
    }
    if (songay == 3) {
      cols = [
        { "name": "stt", "label": "STT", "horizontalalignment": "center" },
        { "name": "serial", "label": "Serial", "horizontalalignment": "right" },
        { "name": "type", "label": "Chủng loại", "horizontalalignment": "left" },
        { "name": "version", "label": "Version", "horizontalalignment": "center" },
        { "name": "rfid", "label": "RFID", "horizontalalignment": "right" },
        { "name": "direction", "label": "Định tuyến", "horizontalalignment": "left" },
        { "name": "thoidiemgannhat", "label": "Thời gian gần nhất", "horizontalalignment": "center" },
        { "name": "status_now", "label": "Kết quả routing hiện tại", "horizontalalignment": "left" },
        { "name": "ngay1_tt", "label": tungay, "horizontalalignment": "left" },
        { "name": "ngay2_tt", "label": ngay1, "horizontalalignment": "left" },
        { "name": "ngay3_tt", "label": ngay2, "horizontalalignment": "left" },
        { "name": "tyle", "label": "Tỷ lệ (%)", "horizontalalignment": "right" },
      ]
    }
    if (songay == 4) {
      cols = [
        { "name": "stt", "label": "STT", "horizontalalignment": "center" },
        { "name": "serial", "label": "Serial", "horizontalalignment": "right" },
        { "name": "type", "label": "Chủng loại", "horizontalalignment": "left" },
        { "name": "version", "label": "Version", "horizontalalignment": "center" },
        { "name": "rfid", "label": "RFID", "horizontalalignment": "right" },
        { "name": "direction", "label": "Định tuyến", "horizontalalignment": "left" },
        { "name": "thoidiemgannhat", "label": "Thời gian gần nhất", "horizontalalignment": "center" },
        { "name": "status_now", "label": "Kết quả routing hiện tại", "horizontalalignment": "left" },
        { "name": "ngay1_tt", "label": tungay, "horizontalalignment": "left" },
        { "name": "ngay2_tt", "label": ngay1, "horizontalalignment": "left" },
        { "name": "ngay3_tt", "label": ngay2, "horizontalalignment": "left" },
        { "name": "ngay4_tt", "label": ngay3, "horizontalalignment": "left" },
        { "name": "tyle", "label": "Tỷ lệ (%)", "horizontalalignment": "right" },
      ]
    }
    if (songay == 5) {
      cols = [
        { "name": "stt", "label": "STT", "horizontalalignment": "center" },
        { "name": "serial", "label": "Serial", "horizontalalignment": "right" },
        { "name": "type", "label": "Chủng loại", "horizontalalignment": "left" },
        { "name": "version", "label": "Version", "horizontalalignment": "center" },
        { "name": "rfid", "label": "RFID", "horizontalalignment": "right" },
        { "name": "direction", "label": "Định tuyến", "horizontalalignment": "left" },
        { "name": "thoidiemgannhat", "label": "Thời gian gần nhất", "horizontalalignment": "center" },
        { "name": "status_now", "label": "Kết quả routing hiện tại", "horizontalalignment": "left" },
        { "name": "ngay1_tt", "label": tungay, "horizontalalignment": "left" },
        { "name": "ngay2_tt", "label": ngay1, "horizontalalignment": "left" },
        { "name": "ngay3_tt", "label": ngay2, "horizontalalignment": "left" },
        { "name": "ngay4_tt", "label": ngay3, "horizontalalignment": "left" },
        { "name": "ngay5_tt", "label": ngay4, "horizontalalignment": "left" },
        { "name": "tyle", "label": "Tỷ lệ (%)", "horizontalalignment": "right" },
      ]
    }
    if (songay == 6) {
      cols = [
        { "name": "stt", "label": "STT", "horizontalalignment": "center" },
        { "name": "serial", "label": "Serial", "horizontalalignment": "right" },
        { "name": "type", "label": "Chủng loại", "horizontalalignment": "left" },
        { "name": "version", "label": "Version", "horizontalalignment": "center" },
        { "name": "rfid", "label": "RFID", "horizontalalignment": "right" },
        { "name": "direction", "label": "Định tuyến", "horizontalalignment": "left" },
        { "name": "thoidiemgannhat", "label": "Thời gian gần nhất", "horizontalalignment": "center" },
        { "name": "status_now", "label": "Kết quả routing hiện tại", "horizontalalignment": "left" },
        { "name": "ngay1_tt", "label": tungay, "horizontalalignment": "left" },
        { "name": "ngay2_tt", "label": ngay1, "horizontalalignment": "left" },
        { "name": "ngay3_tt", "label": ngay2, "horizontalalignment": "left" },
        { "name": "ngay4_tt", "label": ngay3, "horizontalalignment": "left" },
        { "name": "ngay5_tt", "label": ngay4, "horizontalalignment": "left" },
        { "name": "ngay6_tt", "label": ngay5, "horizontalalignment": "left" },
        { "name": "tyle", "label": "Tỷ lệ (%)", "horizontalalignment": "right" },
      ]
    }
    if (songay == 7) {
      cols = [
        { "name": "stt", "label": "STT", "horizontalalignment": "center" },
        { "name": "serial", "label": "Serial", "horizontalalignment": "right" },
        { "name": "type", "label": "Chủng loại", "horizontalalignment": "left" },
        { "name": "version", "label": "Version", "horizontalalignment": "center" },
        { "name": "rfid", "label": "RFID", "horizontalalignment": "right" },
        { "name": "direction", "label": "Định tuyến", "horizontalalignment": "left" },
        { "name": "thoidiemgannhat", "label": "Thời gian gần nhất", "horizontalalignment": "center" },
        { "name": "status_now", "label": "Kết quả routing hiện tại", "horizontalalignment": "left" },
        { "name": "ngay1_tt", "label": tungay, "horizontalalignment": "left" },
        { "name": "ngay2_tt", "label": ngay1, "horizontalalignment": "left" },
        { "name": "ngay3_tt", "label": ngay2, "horizontalalignment": "left" },
        { "name": "ngay4_tt", "label": ngay3, "horizontalalignment": "left" },
        { "name": "ngay5_tt", "label": ngay4, "horizontalalignment": "left" },
        { "name": "ngay6_tt", "label": ngay5, "horizontalalignment": "left" },
        { "name": "ngay7_tt", "label": ngay6, "horizontalalignment": "left" },
        { "name": "tyle", "label": "Tỷ lệ (%)", "horizontalalignment": "right" },
      ]
    }
    var param = {
      config: JSON.stringify({ namesql: "PKG_TRANGTHAIKETNOIRFMESH.P_LAYDS_GIAMSAT_ROUTING_EXCEL" }),
      para: JSON.stringify({
        v_danhmucid: danhmucid,
        v_imei: imei,
        v_tungay: tungay,
        v_denngay: denngay,
        v_sotrang: 0,
        v_sodong: 100000
      }),
      title: "GIÁM SÁT CHẤT LƯỢNG ROUTING",
      header: tenDanhmuc + " - Từ ngày: " + tungay + ". Đến ngày: " + denngay,
      filename: filename,
      sheets: 'Chất lượng routing',
      columns: cols,
      data: ""
    };
    return this.api.downloadFile("api/ExportExcel", param, filename);
  }

  saveExcel(tenDanhmuc, danhmucid, imei, tungay, denngay, songay) {
    songay = parseInt(songay);
    let fromDate = this.dateService.strToDatetime(tungay, 'DD-MM-YYYY');
    let ngay1 = this.dateService.convertDatetoDateOnlyString(this.dateService.addDateTime(fromDate, 1));
    let ngay2 = this.dateService.convertDatetoDateOnlyString(this.dateService.addDateTime(fromDate, 2));
    let ngay3 = this.dateService.convertDatetoDateOnlyString(this.dateService.addDateTime(fromDate, 3));
    let ngay4 = this.dateService.convertDatetoDateOnlyString(this.dateService.addDateTime(fromDate, 4));
    let ngay5 = this.dateService.convertDatetoDateOnlyString(this.dateService.addDateTime(fromDate, 5));
    let ngay6 = this.dateService.convertDatetoDateOnlyString(this.dateService.addDateTime(fromDate, 6));
    let cols = [];
    let dateNow = new Date();
    let strDate = dateNow.getDate() + "-" + (dateNow.getMonth() + 1) + "-" + dateNow.getFullYear();
    let filename = "Chatluongrouting_" + tenDanhmuc + "_" + strDate + '.xlsx';
    if (songay == 1) {
      cols = [
        { "name": "stt", "label": "STT", "horizontalalignment": "center" },
        { "name": "serial", "label": "Serial", "horizontalalignment": "right" },
        { "name": "type", "label": "Chủng loại", "horizontalalignment": "left" },
        { "name": "version", "label": "Version", "horizontalalignment": "center" },
        { "name": "rfid", "label": "RFID", "horizontalalignment": "right" },
        { "name": "direction", "label": "Định tuyến", "horizontalalignment": "left" },
        { "name": "thoidiemgannhat", "label": "Thời gian gần nhất", "horizontalalignment": "center" },
        { "name": "status_now", "label": "Kết quả routing hiện tại", "horizontalalignment": "left" },
        { "name": "ngay1_tt", "label": tungay, "horizontalalignment": "left" },
        { "name": "tyle", "label": "Tỷ lệ (%)", "horizontalalignment": "right" },
      ]
    }
    if (songay == 2) {
      cols = [
        { "name": "stt", "label": "STT", "horizontalalignment": "center" },
        { "name": "serial", "label": "Serial", "horizontalalignment": "right" },
        { "name": "type", "label": "Chủng loại", "horizontalalignment": "left" },
        { "name": "version", "label": "Version", "horizontalalignment": "center" },
        { "name": "rfid", "label": "RFID", "horizontalalignment": "right" },
        { "name": "direction", "label": "Định tuyến", "horizontalalignment": "left" },
        { "name": "thoidiemgannhat", "label": "Thời gian gần nhất", "horizontalalignment": "center" },
        { "name": "status_now", "label": "Kết quả routing hiện tại", "horizontalalignment": "left" },
        { "name": "ngay1_tt", "label": tungay, "horizontalalignment": "left" },
        { "name": "ngay2_tt", "label": ngay1, "horizontalalignment": "left" },
        { "name": "tyle", "label": "Tỷ lệ (%)", "horizontalalignment": "right" },
      ]
    }
    if (songay == 3) {
      cols = [
        { "name": "stt", "label": "STT", "horizontalalignment": "center" },
        { "name": "serial", "label": "Serial", "horizontalalignment": "right" },
        { "name": "type", "label": "Chủng loại", "horizontalalignment": "left" },
        { "name": "version", "label": "Version", "horizontalalignment": "center" },
        { "name": "rfid", "label": "RFID", "horizontalalignment": "right" },
        { "name": "direction", "label": "Định tuyến", "horizontalalignment": "left" },
        { "name": "thoidiemgannhat", "label": "Thời gian gần nhất", "horizontalalignment": "center" },
        { "name": "status_now", "label": "Kết quả routing hiện tại", "horizontalalignment": "left" },
        { "name": "ngay1_tt", "label": tungay, "horizontalalignment": "left" },
        { "name": "ngay2_tt", "label": ngay1, "horizontalalignment": "left" },
        { "name": "ngay3_tt", "label": ngay2, "horizontalalignment": "left" },
        { "name": "tyle", "label": "Tỷ lệ (%)", "horizontalalignment": "right" },
      ]
    }
    if (songay == 4) {
      cols = [
        { "name": "stt", "label": "STT", "horizontalalignment": "center" },
        { "name": "serial", "label": "Serial", "horizontalalignment": "right" },
        { "name": "type", "label": "Chủng loại", "horizontalalignment": "left" },
        { "name": "version", "label": "Version", "horizontalalignment": "center" },
        { "name": "rfid", "label": "RFID", "horizontalalignment": "right" },
        { "name": "direction", "label": "Định tuyến", "horizontalalignment": "left" },
        { "name": "thoidiemgannhat", "label": "Thời gian gần nhất", "horizontalalignment": "center" },
        { "name": "status_now", "label": "Kết quả routing hiện tại", "horizontalalignment": "left" },
        { "name": "ngay1_tt", "label": tungay, "horizontalalignment": "left" },
        { "name": "ngay2_tt", "label": ngay1, "horizontalalignment": "left" },
        { "name": "ngay3_tt", "label": ngay2, "horizontalalignment": "left" },
        { "name": "ngay4_tt", "label": ngay3, "horizontalalignment": "left" },
        { "name": "tyle", "label": "Tỷ lệ (%)", "horizontalalignment": "right" },
      ]
    }
    if (songay == 5) {
      cols = [
        { "name": "stt", "label": "STT", "horizontalalignment": "center" },
        { "name": "serial", "label": "Serial", "horizontalalignment": "right" },
        { "name": "type", "label": "Chủng loại", "horizontalalignment": "left" },
        { "name": "version", "label": "Version", "horizontalalignment": "center" },
        { "name": "rfid", "label": "RFID", "horizontalalignment": "right" },
        { "name": "direction", "label": "Định tuyến", "horizontalalignment": "left" },
        { "name": "thoidiemgannhat", "label": "Thời gian gần nhất", "horizontalalignment": "center" },
        { "name": "status_now", "label": "Kết quả routing hiện tại", "horizontalalignment": "left" },
        { "name": "ngay1_tt", "label": tungay, "horizontalalignment": "left" },
        { "name": "ngay2_tt", "label": ngay1, "horizontalalignment": "left" },
        { "name": "ngay3_tt", "label": ngay2, "horizontalalignment": "left" },
        { "name": "ngay4_tt", "label": ngay3, "horizontalalignment": "left" },
        { "name": "ngay5_tt", "label": ngay4, "horizontalalignment": "left" },
        { "name": "tyle", "label": "Tỷ lệ (%)", "horizontalalignment": "right" },
      ]
    }
    if (songay == 6) {
      cols = [
        { "name": "stt", "label": "STT", "horizontalalignment": "center" },
        { "name": "serial", "label": "Serial", "horizontalalignment": "right" },
        { "name": "type", "label": "Chủng loại", "horizontalalignment": "left" },
        { "name": "version", "label": "Version", "horizontalalignment": "center" },
        { "name": "rfid", "label": "RFID", "horizontalalignment": "right" },
        { "name": "direction", "label": "Định tuyến", "horizontalalignment": "left" },
        { "name": "thoidiemgannhat", "label": "Thời gian gần nhất", "horizontalalignment": "center" },
        { "name": "status_now", "label": "Kết quả routing hiện tại", "horizontalalignment": "left" },
        { "name": "ngay1_tt", "label": tungay, "horizontalalignment": "left" },
        { "name": "ngay2_tt", "label": ngay1, "horizontalalignment": "left" },
        { "name": "ngay3_tt", "label": ngay2, "horizontalalignment": "left" },
        { "name": "ngay4_tt", "label": ngay3, "horizontalalignment": "left" },
        { "name": "ngay5_tt", "label": ngay4, "horizontalalignment": "left" },
        { "name": "ngay6_tt", "label": ngay5, "horizontalalignment": "left" },
        { "name": "tyle", "label": "Tỷ lệ (%)", "horizontalalignment": "right" },
      ]
    }
    if (songay == 7) {
      cols = [
        { "name": "stt", "label": "STT", "horizontalalignment": "center" },
        { "name": "serial", "label": "Serial", "horizontalalignment": "right" },
        { "name": "type", "label": "Chủng loại", "horizontalalignment": "left" },
        { "name": "version", "label": "Version", "horizontalalignment": "center" },
        { "name": "rfid", "label": "RFID", "horizontalalignment": "right" },
        { "name": "direction", "label": "Định tuyến", "horizontalalignment": "left" },
        { "name": "thoidiemgannhat", "label": "Thời gian gần nhất", "horizontalalignment": "center" },
        { "name": "status_now", "label": "Kết quả routing hiện tại", "horizontalalignment": "left" },
        { "name": "ngay1_tt", "label": tungay, "horizontalalignment": "left" },
        { "name": "ngay2_tt", "label": ngay1, "horizontalalignment": "left" },
        { "name": "ngay3_tt", "label": ngay2, "horizontalalignment": "left" },
        { "name": "ngay4_tt", "label": ngay3, "horizontalalignment": "left" },
        { "name": "ngay5_tt", "label": ngay4, "horizontalalignment": "left" },
        { "name": "ngay6_tt", "label": ngay5, "horizontalalignment": "left" },
        { "name": "ngay7_tt", "label": ngay6, "horizontalalignment": "left" },
        { "name": "tyle", "label": "Tỷ lệ (%)", "horizontalalignment": "right" },
      ]
    }
    let user = this.userService.getCurrentUser().mataikhoan;

    var param = {
      config: JSON.stringify({ namesql: "PKG_TRANGTHAIKETNOIRFMESH.P_LAYDS_GIAMSAT_ROUTING_EXCEL" }),
      para: JSON.stringify({
        v_danhmucid: danhmucid,
        v_imei: imei,
        v_tungay: tungay,
        v_denngay: denngay,
        v_sotrang: 0,
        v_sodong: 100000
      }),
      title: "GIÁM SÁT CHẤT LƯỢNG ROUTING",
      header: tenDanhmuc + " - Từ ngày: " + tungay + ". Đến ngày: " + denngay,
      filename: filename,
      sheets: 'Chất lượng routing',
      columns: cols,
      data: "",
      mataikhoan: user,
      danhmucid: danhmucid,
      loaibaocao: 6,
      tenbaocao: "Chất lượng routingg",
    };
    return this.api.Excute("api/SaveExcel", param);
  }
}



// WEBPACK FOOTER //
// /media/tranhien/34DCFEAFDCFE6B0E/SourceCode/AMISS4/AMISS4_PC1_LINUX/src/app/services/thong-ke-trang-thai/chat-luong-routing/chatluongrouting.service.ts